import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Filter, toFilterXml } from '../../dataObjects/Filter';
import { Order, toOrderXml } from '../../dataObjects/Order';

export interface IListMessageContainerNotificationRequest extends IBaseRequest {
    limit?:     string;
    offset?:    string;
    orderBy?:   string;
    countOnly?: string;
    FILTER?:    Filter;
    ORDER?:     Order;
}

export class ListMessageContainerNotificationRequest extends BaseRequest implements IListMessageContainerNotificationRequest {

    public limit?:     string;
    public offset?:    string;
    public orderBy?:   string;
    public countOnly?: string;
    public FILTER?:    Filter;
    public ORDER?:     Order;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
        this.orderBy = otherOptions.orderBy;
        this.countOnly = otherOptions.countOnly;
        this.FILTER = otherOptions.FILTER;
        this.ORDER = otherOptions.ORDER
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        if (this.FILTER) parameters += toFilterXml(this.FILTER);
        if (this.ORDER) parameters += toOrderXml(this.ORDER);

        return super.wrapperXml('ListMessageContainerNotification', parameters);
    }
}
